import * as React from 'react';
import Grid from '@material-ui/core/Grid'
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import ICommunityConfig from "../types/ICommunityConfig";
import CardContent from "@material-ui/core/CardContent";
import { Link } from "react-router-dom";
import { ICommunityStatistic } from "../types/ICommunityStatistic";

interface IProps {
  community: ICommunityConfig,
  communityStatistic: ICommunityStatistic | undefined
}

interface IState {
}

class CommunityCard extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props);

  }

  public render() {
    const activeMemberships = this.props.communityStatistic ? this.props.communityStatistic.totalMemberships : 0;
    const pendingMemberships: number = this.props.communityStatistic ? this.props.communityStatistic.pendingMemberships : 0;

    return (
      <Grid item xs={3}>
        <Card style={{ width: "auto", padding: 8, height: "100%" }}>
          <Grid container direction="column" justify="space-between" alignItems="center"
                style={{ height: "100%", width: "auto" }}>
            <Grid item>
              <CardContent>
                <Grid container justify="flex-start" style={{ height: 200, width: "100%" }}>
                  <div
                    style={{
                      width: "100%",
                      maxWidth: "100%",
                      padding: 0,
                      backgroundImage: `url(${this.props.community.logoUrl}`,
                      backgroundSize: "contain",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center,center"
                    }}
                    title={this.props.community.name}
                  />
                </Grid>
              </CardContent>
              <CardContent>
                <Typography variant="title" align="center" style={{ fontSize: "1em", fontWeight: "bold" }}>
                  {this.props.community.name}
                </Typography>
              </CardContent>
              <CardContent>
                <Typography align="center" style={{ fontSize: "1em" }}>
                  Active: {activeMemberships} members
                </Typography>
                <Typography align="center" style={{ fontSize: "1em" }}>
                  Pending: {pendingMemberships} members
                </Typography>
              </CardContent>
            </Grid>
            <Grid item>
              <CardActions>
                <Link
                  to={{
                    pathname: `/community-management/${this.props.community.code}/memberships`,
                    state: {
                      pendingMembershipsPresent: !!pendingMemberships
                    },
                  }}>
                  <Button size="small" color="primary">
                    MANAGE
                  </Button>
                </Link>
              </CardActions>
            </Grid>
          </Grid>
        </Card>
      </Grid>
    )
  }
}

export default CommunityCard;


// WEBPACK FOOTER //
// ./src/modules/communities/components/CommunityCard.tsx